import { useEffect, useRef } from "react";
import { Form, useActionData, useNavigation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import supportImg from "../../../assets/support-svg.svg";
import "./Support.css";

import { API_BASE_URL } from "../../../config";

export default function Support() {
  const nameInput = useRef();
  const emailInput = useRef();
  const phoneInput = useRef();
  const messageInput = useRef();
  const errorData = useActionData();
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  useEffect(() => {
    if (errorData?.success) {
      toast.success(errorData.message);
      nameInput.current.value = "";
      emailInput.current.value = "";
      phoneInput.current.value = "";
      messageInput.current.value = "";
    }

    if (errorData?.error) {
      toast.error(errorData.message);
      nameInput.current.value = "";
      emailInput.current.value = "";
      phoneInput.current.value = "";
      messageInput.current.value = "";
    }
  }, [errorData]);
  return (
    <>
      <section id="support">
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="container-fluid">
          <div className="row-essy items-center-essy">
            <div className="col-essy-lg-6 col-essy-md-6">
              <div className="support-wrapper">
                <h1>Support</h1>
                <Form method="post">
                  <div className="form-group">
                    <label htmlFor="">Name</label>
                    <input
                      ref={nameInput}
                      type="text"
                      placeholder="Full Name"
                      name="name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="">Email</label>
                    <input
                      ref={emailInput}
                      type="email"
                      placeholder="example@email.com"
                      name="email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="">Phone</label>
                    <input
                      ref={phoneInput}
                      type="tel"
                      placeholder="000 00 00 000"
                      name="phone"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="">Message</label>
                    <textarea
                      ref={messageInput}
                      name="message"
                      placeholder="Your Message"
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="btn-all-white">
                    {isSubmitting ? "Submitting.." : "Submit"}
                  </button>
                </Form>
              </div>
            </div>
            <div className="col-essy-lg-6 col-essy-md-6">
              <div className="support-img-col">
                <img src={supportImg} alt="support" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export const supportDataAction = async ({ request }) => {
  const formData = await request.formData();

  const data = {
    name: formData.get("name"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    message: formData.get("message"),
  };

  const response = await fetch(`${API_BASE_URL}/contact-support`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  console.log(result);

  if (result.success === false) {
    return {
      error:
        result.errors ||
        result.message ||
        "Sending message failed. Please try again",
    };
  }

  return { success: true, message: result.message };
};
